import { request } from "./http";

export const passwords = {
  forgot: (email: string) =>
    request<unknown>("/auth/forgot-password", { body: { email } }),
  reset: (token: string, password: string) =>
    request<unknown>("/auth/reset-password", { body: { token, password } }),
};

export const verification = {
  request: (email: string) =>
    request<unknown>("/auth/request-verify-token", { body: { email } }),
  verify: (token: string) =>
    request<unknown>("/auth/verify", { body: { token } }),
};

/** Update fields on the current user via fastapi-users PATCH /users/me. */
export const userMe = {
  patch: (body: { full_name?: string; locale?: string; password?: string }) =>
    request<unknown>("/users/me", { method: "PATCH", body }),
};
